import { ChangeEmailErrorKind } from '@griply/types';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { ChangeEmailForm } from 'shared/components/ui/change-email-form';

import * as Styled from './change-email.style';

export type ChangeEmailDialogProps = {
  open?: boolean;
  currentEmail: string;
  // The address the confirmation link went to; set once it is sent.
  sentTo?: string;
  isLoading?: boolean;
  error?: ChangeEmailErrorKind;
  onSubmit: (newEmail: string, password: string) => void;
  onClose: () => void;
};

export const ChangeEmailDialog: React.FC<ChangeEmailDialogProps> = ({
  open,
  currentEmail,
  sentTo,
  isLoading,
  error,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={!!open} onClose={!isLoading ? onClose : undefined}>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {t(
            sentTo ? 'auth.change-email.sent.title' : 'auth.change-email.title',
          )}
        </Typography>
        {!sentTo && (
          <Typography variant="body2" color="text.secondary">
            {t('auth.change-email.description')}
          </Typography>
        )}
      </Styled.Header>

      <Styled.Body>
        {sentTo ? (
          <>
            <Typography variant="body2">
              {t('auth.change-email.sent.message', {
                email: sentTo,
                currentEmail,
              })}
            </Typography>
            <Styled.Interactions>
              <Button
                variant={Variants.Contained}
                color={Colors.Primary}
                size={Sizes.Medium}
                onClick={onClose}
              >
                {t('general.done')}
              </Button>
            </Styled.Interactions>
          </>
        ) : (
          <ChangeEmailForm
            currentEmail={currentEmail}
            onSubmit={onSubmit}
            onCancel={onClose}
            isLoading={!!isLoading}
            error={error}
          />
        )}
      </Styled.Body>
    </Dialog>
  );
};
